import { atom } from 'recoil';

import { NewWithdrawalAtom } from './types';

export const newWithdrawalAtom = atom<NewWithdrawalAtom>({
  key: 'newWithdrawal',
  default: {
    selectedBank: 0,
    value: 0,
    withdrawalDate: new Date(),
    requestDate: new Date(),
    withdrawAll: false,
    token: '',
  },
});

export const newWithdrawalDownloadingReceiptAtom = atom({
  key: 'newWithdrawalDownloadingReceipt',
  default: false,
});

export const newWithdrawalCreatingAtom = atom({
  key: 'newWithdrawalCreating',
  default: false,
});
